/**
 * Site-wide referral capture. Watches the URL for a `?ref=<code>` param and
 * persists it to a first-party cookie so it survives navigation and is still
 * available when the visitor eventually signs up. Renders nothing.
 */
import { useLocation } from "@tanstack/react-router";
import { useEffect } from "react";

import {
  REF_CODE_COOKIE_NAME,
  REF_CODE_MAX_AGE_SECONDS,
  REFERRAL_QUERY_PARAM,
  isValidReferralCode,
} from "~/lib/shared/referral";

const isBrowser = typeof document !== "undefined";

export function ReferralCapture(): null {
  const location = useLocation();

  useEffect(() => {
    if (!isBrowser) {
      return;
    }

    const search =
      typeof location.search === "string"
        ? location.search
        : window.location.search;
    const code = new URLSearchParams(search).get(REFERRAL_QUERY_PARAM);
    if (!isValidReferralCode(code)) {
      return;
    }

    const secure = window.location.protocol === "https:" ? "; secure" : "";
    document.cookie = `${REF_CODE_COOKIE_NAME}=${encodeURIComponent(code)}; path=/; max-age=${REF_CODE_MAX_AGE_SECONDS}; samesite=lax${secure}`;
  }, [location.search]);

  return null;
}
